import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { ZhhSessionLimitConfigService } from "./zhh-session-limit.config";
import { ZhhSessionLimitState } from "./zhh-session-limit.model";

@Injectable({
	providedIn: "root",
})
export class ZhhSessionLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: ZhhSessionLimitConfigService
	) {}

	get(): Observable<ZhhSessionLimitState> {
		return this.httpClient.get<ZhhSessionLimitState>({
			url: this.config.getZhhSessionLimitEndpoint(),
		});
	}
}
